import React, {useEffect} from 'react';
import {Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {hasOneOfPermission, Permissions} from '../../../store/reducers/user';
import {StyledBadge} from '../../header/patientInfo';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PatientAlarms from '../../../pages/ward/forms/alarms/patientAlarms';
import {useDispatch, useSelector} from 'react-redux';
import {agyleOpenAlarms} from '../../../store/reducers/globals';
import useOpenState from '../../../hooks/useOpenState';
import {useTranslation} from 'react-i18next';
import * as _filter from 'lodash/filter';
import moment from 'moment/moment';
import {additionalData} from '../../../store/reducers/additionalData';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import {useHeaderIconStyles} from './iconStyle';
import clsx from 'clsx';

const PatientAlarmsButton = ({patient, disableSave}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const classes = useHeaderIconStyles();

    // Selectors
    const openAlarmFromSystem = useSelector(agyleOpenAlarms);
    const patientAddData = useSelector(additionalData);

    // Open states
    const [isAlarmOpen, openAlarm, closeAlarm] = useOpenState(false, true);

    const [ack, setAck] = React.useState(false);
    const [activeAlerts, setActiveAlerts] = React.useState([]);

    useEffect(() => {
        if (openAlarmFromSystem && !!patient?.__id) {
            setAck(true);
            openAlarm();
        }
    }, [openAlarmFromSystem, patient]);

    useEffect(() => {
        if (patient?.patient?.__id === patientAddData?.__id) {
            setActiveAlerts(_filter(patientAddData?.other?.alarms, (alarmEl) => {
                return (!alarmEl.deleted && moment(alarmEl.expireDate).isAfter(moment()));
            }));
        }
    }, [patient, patientAddData]);

    const handleCloseAlarms = () => {
        closeAlarm();
        setAck(false);
    };

    return (
        <>
            <Tooltip title={t('Patient alarms')}>
                <span>
                    <IconButton
                        onClick={openAlarm}
                        size="small"
                        className={clsx(classes.iconHover, isAlarmOpen && classes.iconButton)}
                        disabled={!dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_OPEN_PATIENT_RECORD, Permissions.AGYLE_CAN_VIEW_ONLY]))}
                        disableRipple
                        color={isAlarmOpen ? 'primary' : 'default'}
                    >
                        <StyledBadge
                            badgeContent={activeAlerts?.length}
                            color="primary"
                        >
                            {activeAlerts?.length === 0 ? <NotificationsNoneOutlinedIcon/> : <NotificationsIcon/>}
                        </StyledBadge>
                    </IconButton>
                </span>
            </Tooltip>

            {(isAlarmOpen && patient) &&
                <PatientAlarms
                    patient={patient?.patient}
                    open={isAlarmOpen}
                    spellId={patient?.__id}
                    disableSave={disableSave}
                    close={handleCloseAlarms}
                    fromSearch={false}
                    acknowledge={ack}
                    currentPiW={patient}
                />
            }
        </>
    );
};

export default PatientAlarmsButton;